import { PlatformLocation } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Agency } from 'src/app/domain/agency';
import { StrategyService } from 'src/app/services/strategy.service';

@Component({
    selector: 'app-agency',
    templateUrl: './agency.component.html',
    styleUrls: ['./agency.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgencyComponent implements OnInit {

    Agency: Agency;

    constructor(
        private platformLocation: PlatformLocation,
        private strategyService: StrategyService,
        private route: ActivatedRoute) { }

    ngOnInit(): void {
        this.getAgencyInformation();
    }

    getAgencyInformation() {

        this.strategyService.getStrategyById(this.route.snapshot.params['id']).subscribe(x => {
            this.Agency = x.SamplingAgency ? x.SamplingAgency : x.Agency;
        });
    }

    getLabImg() {
        return `${(this.platformLocation).hostname}/../assets/banniere-amiante-eurofins.png`;
    }
}
